import { AdminStaffScreen } from '@features/admin/ui/AdminStaffScreen'
import { PermissionGate } from '@shared/ui/PermissionGate'

export function EquipePage() {
  return (
    <PermissionGate permission="STAFF_MANAGE">
      <AdminStaffScreen />
    </PermissionGate>
  )
}
